import L from 'lodash'

const onLoad = function(): void {
  const initialLoadingStyles = document.querySelector(
    '[data-type="initial-loading"]',
  )

  if (!L.isNull(initialLoadingStyles)) {
    document.head.removeChild(initialLoadingStyles)
  }

  window.onafterload()
}

// eslint-disable-next-line fp/no-mutation
window.onload = onLoad
